import Component from '@glimmer/component';
import fade from 'ember-animated/transitions/fade';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';
import { task } from 'ember-concurrency';
import checkImage from '@dubbletrack/toolbox/utils/check-image';
import { inject as service } from '@ember/service';
export default class DeluxePlayerArtworkComponent extends Component {
  fade = fade;

  @tracked bestImageSource;

  @service settings;

  // The feed already ranks airing, show, airing.show and station, and ranking again here missed airing.show.
  loadBestImageSourceTask = task(async (feed) => {
    let source = (feed || this.args.feed)?.imageSource;

    if (!source) {
      this.bestImageSource = undefined;
      return;
    }

    try {
      await checkImage(source.medium_square?.url);
      this.bestImageSource = source;
    } catch {
      this.bestImageSource = undefined;
    }
  });

  @action
  colorSlurp() {
    // Vibrant.from(this.bestImageSource.medium_square.url)
    //   .getPalette()
    //   .then((palette) => {
    //     this.settings.colorOptions = palette;
    //   });
  }

  get bestImageSource() {
    return (
      this.airingImageSource ||
      this.showImageSource ||
      this.stationImageSource ||
      this.fallbackImageSource
    );
  }
}
